import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../../../components/SettingsBreadcrumb';
import './inserir-modelo-3.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import * as api from '../../../../../../api/outrasPaginas';
import Swal from 'sweetalert2';
import QuillEditor from '../../../../../../components/common/QuillEditor';
import { FaEye } from 'react-icons/fa';

const InserirPaginaModelo3: React.FC = () => {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    dscUrl: { value: string; error: boolean };
    descricao: { value: string; error: boolean };
  }>({
    titulo: { value: '', error: false },
    dscUrl: { value: '', error: false },
    descricao: { value: '', error: false },
  });

  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);

  const {
    isOpen: isPreviewAberto,
    onOpen: onPreviewAberto,
    onClose: onPreviewFechado
  } = useDisclosure()

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const isFormValid = () => {
    const { titulo, dscUrl, descricao } = formValues;
    return (
      titulo.value.trim() !== "" &&
      descricao.value.trim() !== "" &&
      dscUrl.value.trim() !== ""
    );
  };

  const formataData = (date: Date) => {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);

    try {
      const jsonModeloData = {
        codModeloPagina: 3,
        tituloGeral: formValues.titulo.value,
        descricao: formValues.descricao.value,
      };

      const params = {
        nomPagina: formValues.titulo.value || null,
        dscUrl: formValues.dscUrl.value || null,
        datRegistro: formataData(new Date()),
        txtHtml: null,
        numHtmlProprio: 0,
        numBloqueada: 0,
        sitRegistro: 1,
        datInativo: null,
        codModeloPagina: 3,
        jsonModelo: JSON.stringify(jsonModeloData)
      };

      await api.inserirPagina(params);
      setLoadingButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Página inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente/outras-paginas');
      });
    } catch (error) {
      console.error('Erro ao inserir página:', error);
      if (typeof error === 'string' && error.includes('Erro ao atualizar a Pagina')) {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'O nome da página já está em uso. Por favor, escolha outro.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'Erro ao inserir página. Tente novamente mais tarde.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
      }
      setLoadingButton(false);
    }
  };

  const carregarPreview = () => (
    <Box p={6} maxW="900px" mx="auto">
      <Heading as="h2" fontSize="2xl" color="#004a7f" mb={4} textAlign="center">
        {formValues.titulo.value}
      </Heading>
      <Box
        className="preview-content"
        fontSize="md"
        lineHeight="1.7"
        textAlign="justify"
        dangerouslySetInnerHTML={{ __html: formValues.descricao.value }}
      />
    </Box>
  );

  return (
    <Flex direction="column" padding="40px" backgroundColor="#fafafa" width="100%" height="100%" overflow="hidden">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Modelo 3 - Texto Livre
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row mb-3">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Título Geral</FormLabel>
                <CustomInput
                  placeholder="Digite um título"
                  value={formValues.titulo.value}
                  maxLength={100}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                />
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.dscUrl.error}>
                <FormLabel mb="8px">URL da Página</FormLabel>
                <CustomInput
                  placeholder="Digite uma URL"
                  value={formValues.dscUrl.value}
                  onChange={(e) => handleFieldChange('dscUrl', e.target.value)}
                  maxLength={512}
                />
              </FormControl>
            </div>
          </div>
          <Box mb="20px">
            <FormControl isRequired isInvalid={formValues.descricao.error}>
              <FormLabel>Descrição</FormLabel>
              <QuillEditor
                value={formValues.descricao.value}
                placeholder="Digite uma descrição"
                onChange={(content: string) => handleFieldChange("descricao", content)}
              />
            </FormControl>
          </Box>
          <Flex mt="35px" justifyContent="end">
            <Button m="6px" onClick={() => navigate('/cms/edicao-cidade-inteligente/outras-paginas/inserir-pagina')}>
              Desistir
            </Button>
            <Button
              mt="6px"
              leftIcon={<FaEye />}
              variant="outline"
              onClick={onPreviewAberto}
            >
              Ver Preview
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Inserindo..."
            >
              Inserir Página Modelo
            </Button>
          </Flex>
        </form>
      </Box>
      <Modal isOpen={isPreviewAberto} onClose={onPreviewFechado} size="full" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={'#004a7f'} fontWeight={'bold'}></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {carregarPreview()}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onPreviewFechado}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default InserirPaginaModelo3;
